import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetUserSucceed, EGetUserActionTypes } from './types';
import { TUserState } from '../../../types/user';

export const getUserSucceed: (user: TUserState) => TGetUserSucceed = actionGenerator<
  EGetUserActionTypes.Succeed,
  TUserState
>(EGetUserActionTypes.Succeed);
